import React from 'react';
import { Link } from 'react-router-dom';
import { FaFlask, FaUsers, FaEnvelope } from 'react-icons/fa6';
import API_URL from '../../config';

const GUEST_DAILY_LIMIT = 3;
const USER_DAILY_LIMIT = 5;

function WalletRiskInfoPanel({ t, isAuthenticated, rateLimitRemaining }) {
  const dailyLimit = isAuthenticated ? USER_DAILY_LIMIT : GUEST_DAILY_LIMIT;
  const showUrgentCta =
    rateLimitRemaining !== null && rateLimitRemaining <= 1;

  const waitlistState = {
    subject: t('waitlistDefaultSubject'),
    message: t('waitlistDefaultMessage'),
  };

  return (
    <div className="space-y-4 mt-8">
      <div className="rounded-2xl border border-purple-200/60 dark:border-purple-700/40 bg-white dark:bg-gray-800 shadow-sm overflow-hidden">
        <div className="bg-gradient-to-r from-purple-500/10 to-indigo-500/10 dark:from-purple-900/30 dark:to-indigo-900/30 px-5 py-4 border-b border-purple-200/40 dark:border-purple-700/30">
          <div className="flex items-center gap-2">
            <FaFlask className="text-purple-500 dark:text-purple-300" />
            <span className="text-xs font-bold uppercase tracking-widest text-purple-600 dark:text-purple-300">
              {t('walletRiskBetaBadge')}
            </span>
          </div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white mt-2">
            {t('walletRiskBetaTitle')}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-300 mt-2 leading-relaxed">
            {t('walletRiskBetaDescription')}
          </p>
        </div>

        <div className="px-5 py-4">
          <div className="rounded-xl border border-gray-200 dark:border-gray-700 p-4">
            <p className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2">
              {t('walletRiskQuotaTitle')}
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between items-center">
                <span className="text-gray-700 dark:text-gray-300">{t('walletRiskQuotaGuest')}</span>
                <span className="font-semibold text-gray-900 dark:text-white">
                  {t('walletRiskQuotaPerDay', { count: GUEST_DAILY_LIMIT })}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-700 dark:text-gray-300">{t('walletRiskQuotaLoggedIn')}</span>
                <span className="font-semibold text-purple-600 dark:text-purple-300">
                  {t('walletRiskQuotaPerDay', { count: USER_DAILY_LIMIT })}
                </span>
              </div>
            </div>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-3 leading-relaxed">
              {t('walletRiskQuotaExplain')}
            </p>
            {rateLimitRemaining !== null && (
              <p className="text-xs font-medium text-purple-600 dark:text-purple-300 mt-2">
                {t('rateLimitRemaining', { count: rateLimitRemaining })} / {dailyLimit}
              </p>
            )}
          </div>
        </div>

        {!isAuthenticated && (
          <div className="px-5 pb-4">
            <a
              href={`${API_URL}/api/auth/google`}
              className="inline-flex items-center gap-2 text-sm font-semibold text-purple-600 dark:text-purple-300 hover:underline"
            >
              <FaUsers />
              {t('walletRiskLoginForMore')}
            </a>
          </div>
        )}
      </div>

      <div
        className={`rounded-2xl border p-5 shadow-sm ${
          showUrgentCta
            ? 'border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-950/20'
            : 'border-purple-200/60 dark:border-purple-700/40 bg-gradient-to-br from-purple-50 to-indigo-50 dark:from-purple-950/30 dark:to-indigo-950/20'
        }`}
      >
        <div className="flex items-start gap-3">
          <FaEnvelope className="text-purple-500 dark:text-purple-300 mt-1 shrink-0" />
          <div className="flex-1">
            <h4 className="text-base font-bold text-gray-900 dark:text-white">
              {showUrgentCta ? t('waitlistUrgentTitle') : t('waitlistTitle')}
            </h4>
            <p className="text-sm text-gray-600 dark:text-gray-300 mt-2 leading-relaxed">
              {showUrgentCta ? t('waitlistUrgentDescription') : t('waitlistDescription')}
            </p>
            <ul className="mt-3 space-y-1 text-sm text-gray-600 dark:text-gray-300">
              <li>· {t('waitlistBenefit1')}</li>
              <li>· {t('waitlistBenefit2')}</li>
              <li>· {t('waitlistBenefit3')}</li>
            </ul>
            <Link
              to="/contact"
              state={waitlistState}
              className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 rounded-xl bg-gradient-to-r from-purple-500 to-indigo-500 text-white text-sm font-semibold shadow-md hover:from-purple-600 hover:to-indigo-600 transition-all"
            >
              {t('waitlistCtaButton')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WalletRiskInfoPanel;
